import { listProductDimension, listCityInfos } from '@/api/dm'
import { getAllByCityCode } from '@/api/rim'

const search = {
  state: {
    preOrderId: 0, // 当前查询订单ID
    searchCondition: {}, // 查询条件
    purchaseList: [], // 采购清单
    chooseStation: {}, // 选中的站点
    updatePurchase: {}, // 更新采购清单,包含站点信息和更新类型
    searchRouterArray: [], // 路由信息

    showPurchase: null, // 用户点击表格上的关注，强制显示购物车
    beginSearch: new Date(), // 开始查询
    filterData: 0 // 开始过滤数据
  },
  mutations: {
    set_search_searchCondition (state, data) {
      state.searchCondition = data
    },
    set_search_purchaseList (state, data) {
      state.purchaseList = data
    },
    set_search_chooseStation (state, data) {
      state.chooseStation = data
    },
    set_search_preOrderId (state, data) {
      state.preOrderId = data
    },
    set_search_updatePurchase (state, data) {
      state.updatePurchase = data
    },
    set_search_router_array (state, data) {
      state.searchRouterArray = data
    },
    set_search_beginSearch (state, data) {
      state.beginSearch = data
    },
    set_search_showPurchase (state, data) {
      state.showPurchase = data
    },
    set_search_filterData (state, data) {
      state.filterData = data
    }
  },
  actions: {
    // 获取所有可用的城市清单
    getCityList () {
      return new Promise((resolve) => {
        listCityInfos().then(res => {
          resolve(res)
        })
      })
    },
    // 获取所有查询指标
    getDimensionList () {
      return new Promise((resolve) => {
        listProductDimension().then(res => {
          resolve(res)
        })
      })
    },
    // 获取当前城市下所有可用线路
    getAllAssets ({ commit }, cityCode) {
      return new Promise((resolve) => {
        getAllByCityCode({ cityCode: cityCode }).then(res => {
          resolve(res)
        })
      })
    }
  }
}

export default search
